import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { useFormikContext } from 'formik';
import React__default, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { A as AppTextInput } from './index-c2a07f56.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppText } from './index-6b88191c.esm.js';

const ERROR_OFFSET = 3;
var Constants = {
  ERROR_OFFSET
};

function AppErrorMessage(_ref) {
  var _currentTheme$theme;
  let {
    message,
    top = -6
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.red,
      marginLeft: 20,
      top,
      position: "absolute"
    }
  }, message);
}
StyleSheet.create({});
AppErrorMessage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppErrorMessage",
  "props": {
    "top": {
      "defaultValue": {
        "value": "-6",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormField(_ref) {
  let {
    showTextChips,
    name,
    width,
    onChange = () => {},
    formFieldContainerStyle,
    errorOffset,
    ...otherProps
  } = _ref;
  const {
    setFieldTouched,
    setFieldValue,
    errors,
    touched,
    initialValues,
    values
  } = useFormikContext();
  const [inputTags, setInputTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const onChangeValue = value => {
    if (typeof showTextChips === "undefined") setFieldValue(name, value);else setInputValue(value);
    onChange(value);
  };
  // if errors[name] is a json object, stringify it

  const stringifiedError = errors[name] && typeof errors[name] === "object" ? JSON.stringify(errors[name]) : errors[name];
  const onTextChipSubmit = event => {
    var _event$nativeEvent;
    if ((event === null || event === void 0 ? void 0 : (_event$nativeEvent = event.nativeEvent) === null || _event$nativeEvent === void 0 ? void 0 : _event$nativeEvent.text) !== "") {
      inputTags.push(event.nativeEvent.text);
      setInputTags(inputTags);
      setFieldValue(name, inputTags);
      setInputValue("");
    }
  };
  const handleDeleteTagClick = item => {
    if (item) {
      var filtered = inputTags.filter(function (value) {
        return value !== item;
      });
      setInputTags(filtered);
      setFieldValue(name, filtered);
    }
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 3
    }, formFieldContainerStyle]
  }, /*#__PURE__*/React__default.createElement(AppTextInput, _extends({}, otherProps, {
    inputTags: inputTags,
    onDeleteTagClick: handleDeleteTagClick,
    width: width,
    defaultValue: initialValues && initialValues[name],
    onBlur: () => setFieldTouched(name),
    onChangeText: text => onChangeValue(text),
    value: typeof showTextChips === "undefined" ? values[name] : inputValue,
    onEndEditing: item => {
      showTextChips && onTextChipSubmit(item);
    }
  })), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: stringifiedError,
    top: errorOffset
  }));
}
AppFormField.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormField",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppFormField as A, Constants as C, AppErrorMessage as a };
